import React from "react";
import "./self-assessment.css";
import { Renderslickslider } from "./popover-slick-slider";

const Renderpopoverslider = (props) => {
  return (
    <React.Fragment>
      <div className="blur-background" />
      <div className="popover-slider-wrapper">
        <Renderslickslider
          sliderData={props.sliderData}
          showDots={props.showDots}
          handleSlideChange={props.handleSlideChange}
          instrument_id={props.instrument_id}
          user_id={props.user_id}
          participant__id={props.participant__id}
          instrumentMultiRater={props.instrumentMultiRater}
          organisation={props.organisation}
          seller={props.seller}
          completedCount={props.completedCount}
          assessmentType={props.assessmentType}
          invitationDetails={props.invitationDetails}
          startLink={props.startLink}
          slideIndex={props.slideIndex}
        />
      </div>
    </React.Fragment>
  );
};

export default Renderpopoverslider;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/popover-slider.jsx